import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const getPopupList = createAsyncThunk("popup/getPopupList", async () => {
    try {
        const response = await api.get(`popup/list/`);
        if (response.data) return response.data;
        throw new Error("error");
    } catch (error) {
        console.error("Error get popup/list/:", error);
        throw error;
    }
});

const PopupListSlice = createSlice({
    name: "popupList",
    initialState: { data: [], error: null, isLoading: false },
    extraReducers: (builder) => { builder
        .addCase(getPopupList.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getPopupList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        })
        .addCase(getPopupList.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default PopupListSlice.reducer;
